module.exports = __webpack_public_path__ + "img/chr_ts_12.41ddaa87.png";